module.exports = __webpack_public_path__ + "static/img/name6.895e602.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cn/name6.png
// module id = d8Fw
// module chunks = 1